(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["unity-home-product-gallery"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(root){
    root.querySelectorAll('[data-unity-home-gallery]').forEach(function(gallery){
      if(gallery.dataset.ready)return;
      gallery.dataset.ready='true';
      var track=gallery.querySelector('.unity-home-gallery__track');
      var bar=gallery.querySelector('.unity-home-gallery__progress span');
      var count=track.children.length;
      var startX=0,startY=0,moved=false,reset;
      function update(){
        if(bar && track.clientWidth){
          var index=Math.round(track.scrollLeft/track.clientWidth);
          bar.style.transform='translateX('+(Math.max(0,Math.min(count-1,index))*100)+'%)';
        }
      }
      track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('pointerdown',function(e){clearTimeout(reset);startX=e.clientX;startY=e.clientY;moved=false;},{passive:true});
      track.addEventListener('pointermove',function(e){if(Math.abs(e.clientX-startX)>8||Math.abs(e.clientY-startY)>8)moved=true;},{passive:true});
      track.addEventListener('pointerup',function(){reset=setTimeout(function(){moved=false;},350);},{passive:true});
      track.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();}},true);
      track.addEventListener('keydown',function(e){
        if(e.key==='ArrowRight'||e.key==='ArrowLeft'){
          e.preventDefault();
          track.scrollBy({left:(e.key==='ArrowRight'?1:-1)*track.clientWidth,behavior:'auto'});
        }
      });
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["unity-shop-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('unity-shop-gallery')){
  customElements.define('unity-shop-gallery',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.media=matchMedia('(max-width:767px)');
      const setup=()=>{
        if(!this.media.matches||this.dataset.ready)return;
        const track=this.querySelector('.unity-shop-gallery__track');
        const template=this.querySelector('template');
        if(!track||!template)return;
        track.append(template.content.cloneNode(true));
        this.dataset.ready='true';
        const slides=Array.from(track.children);
        const bar=this.querySelector('.unity-shop-gallery__progress span');
        let x=0,y=0,dragged=false,active=false;
        const hydrate=index=>{
          const img=slides[index]?.querySelector('img[data-src]');
          if(img){img.srcset=img.dataset.srcset;img.src=img.dataset.src;delete img.dataset.src;delete img.dataset.srcset;}
        };
        const update=()=>{
          if(!track.clientWidth)return;
          const index=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));
          bar.style.transform='translateX('+(index*100)+'%)';
          if(active){hydrate(index);hydrate(index+1);hydrate(index-1);}
        };
        track.addEventListener('pointerdown',e=>{x=e.clientX;y=e.clientY;dragged=false;active=true;update();},{passive:true,signal});
        track.addEventListener('pointermove',e=>{if(Math.abs(e.clientX-x)>8||Math.abs(e.clientY-y)>8)dragged=true;},{passive:true,signal});
        track.addEventListener('scroll',update,{passive:true,signal});
        track.addEventListener('click',e=>{if(dragged){e.preventDefault();e.stopPropagation();dragged=false;}},{capture:true,signal});
        track.addEventListener('keydown',e=>{
          if(e.key==='ArrowLeft'||e.key==='ArrowRight'){
            e.preventDefault();active=true;update();
            track.scrollBy({left:(e.key==='ArrowRight'?1:-1)*track.clientWidth,behavior:'auto'});
          }
        },{signal});
      };
      this.media.addEventListener('change',setup,{signal});
      setup();
      this.observer=new MutationObserver(setup);
      this.observer.observe(this,{childList:true});
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();delete this.dataset.ready;this.querySelectorAll('.unity-shop-gallery__slide').forEach(el=>el.remove());}
  });
}
  } catch(e) { console.error(e); }
})();

})();
